module Meevo.Plugins.AlertsManager {

    import IAlertCategory = Meevo.Model.IAlertCategory;
    import IAlertSetting = Meevo.Model.IAlertSetting;
    import IntDetail = Meevo.Model.IntDetail;
    import ProactiveAlertTypeEnum = Meevo.Model.ProactiveAlertTypeEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    class MeevoCategoryTabComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            'meevo.components.busy.BusyService',
            '$q',
            '$scope',
            'meevo.components.common.SecurityService',
        ];

        public params: IParams;
        public currentStep: number;

        public alertCategoryList: Array<IAlertCategory> = [];
        public alertSettingList: Array<IAlertSetting> = [];

        public selectedSecurityFeature: IntDetail;
        public disableAlertCategories = false;

        private cachedAlerts: { [key: string]: IAlertSetting[] };
        private productLotModuleEnabled: boolean | null = null;
        private securityKeys = Meevo.Components.Common.SecurityKeys;

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $q: angular.IQService,
                    protected scope: ng.IScope,
                    protected securityChecker: Meevo.Components.Common.ISecurityService) {
            this.cachedAlerts = {};
        }

        $onInit() {
            const moduleCheck = this.securityChecker.checkModuleAccess(this.securityKeys.DATA_PRODUCTLOTEXPIRATIONTRACKINGMODULE + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                .then(access => { this.productLotModuleEnabled = access === SecurityAccessEnum.Grant; });

            if (this.alertsManagerService.alert) {
                this.busyService.start();
                moduleCheck.then(() => this.useEditMode());
                this.disableAlertCategories = true;
            } else {
                this.loadAlertCategoryList();

                const unwatch = this.scope.$watch(() => this.currentStep, (newValue) => {
                    if(typeof newValue === 'number' && newValue !== 0) { // 0 - first tab
                        this.disableAlertCategories = true;
                        unwatch();
                    }
                });
            }
        }

        private useEditMode() {
            let alert = this.alertsManagerService.alert;

            this.$q
                .all([
                    this.loadAlertCategoryList(),
                    this.loadAlertSettingList(<IAlertSetting>{id: alert.cat_SId})
                ])
                .then(() => {
                    this.params.alertSetting = _.find(this.alertSettingList, s => s.id === alert.alert_SId);
                    this.params.alertCategory = _.find(this.alertCategoryList, c => c.id === alert.cat_SId);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Get list of Alerts Settings
         */
        loadAlertSettingList(alertSetting: IAlertSetting): ng.IPromise<void> {
            this.busyService.start();
            return new this.$q(resolve => {
                if (typeof this.cachedAlerts[alertSetting.id.toString()] === 'object') {
                    resolve(this.cachedAlerts[alertSetting.id.toString()]);
                } else {
                    this.alertsManagerService.getAlertSettingList(alertSetting.id).then((data) => resolve(data));
                }
            }).then((data: IAlertSetting[]) => {
                this.params.alertSetting = null;
                this.selectedSecurityFeature = null;
                if (this.productLotModuleEnabled === false) {
                    data = data.filter(s =>
                        s.id !== ProactiveAlertTypeEnum.ExpiredProductLotSold
                        && s.id !== ProactiveAlertTypeEnum.ExpiredProductLotUsed
                        && s.id !== ProactiveAlertTypeEnum.InventoryProductLotApproachingExpiration
                        && s.id !== ProactiveAlertTypeEnum.InventoryProductLotExpired);
                }
                this.alertSettingList = data;
                this.cachedAlerts[alertSetting.id.toString()] = data;
            }).finally(() => {
                this.busyService.stop();
            });
        }


        /**
         * Get list of Alerts Categories
         */
        loadAlertCategoryList(): ng.IPromise<void> {
            this.busyService.start();
            return this.alertsManagerService.getAlertCategoryList()
                .then((data) => {
                    this.alertCategoryList = data;
                }).finally(() => {
                    this.busyService.stop();
                });
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoCategoryTabComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/tabs/category-tab/category-tab.component.html',
            controller: MeevoCategoryTabComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                currentStep: '<',
                onChangeSetting: '&'
            }
        });
}
